import styled from "styled-components"
import theme from "../../../theme"


export const Conferences = styled.section`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  margin-bottom: 20px;
  border: 4px solid ${theme.bg.light};
`

export const ConferenceSection = styled.div`
  display: inline-flex;
  flex-direction: column;
  overflow: hidden;
  padding: 2rem;
  margin-bottom: 32px;

  @media (min-width: 1024px) {
    max-width: 1240px;
    min-width: 920px;
  }
`

export const ConferencesContainer = styled.div`
  width: 100%;
  max-width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  @media (min-width: 1240px) {
    flex-direction: row;
    justify-content: space-between;
    max-width: 1240px;
  }
`

export const ConferenceImage = styled.img`
  max-height: 80px;
  padding: 16px;
  margin-bottom: 16px;

  @media (min-width: 1240px) {
    max-height: 100px;
    max-width: none;
    margin-right: 50px;
    margin-bottom: 0;
  }
`

export const ConferenceLink = styled.a`

`

export const ConferenceTitle = styled.h2`
  font-size: 2rem;
  background-image:linear-gradient(90deg,${theme.brand.default},${theme.brand.alt},${theme.brand.default});
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  font-weight: 600;
  line-height: 1.2;
  letter-spacing: -.015em;
  margin-bottom: 32px;
`
